import { Divider, Stack } from '@chakra-ui/react'

import MFNavHeader from './MFNav.Header'
import MFNavProvider from './MFNav.Provider'
import MFNavSidebarBody from './MFNav.SidebarBody'
import MFNavSidebarContainer from './MFNav.SidebarContainer'
import MFNavSidebarFooter from './MFNav.SidebarFooter'
import MFNavSidebarHeader from './MFNavSidebarHeader'

/**
 * @typedef {Object} MFNavProps
 * @property {import('../../types/admins').MFAdmin} current_admin - The current admin user.
 * @property {boolean | string[]} permissions - Permissions associated with the admin user.
 */

/**
 * MFNav component to provide navigation and context.
 *
 * The `MFNav` component is responsible for rendering the main navigation structure
 * of the application, including the top bar, sidebar header, navigation, and footer.
 * It uses the `MFNavProvider` to supply necessary context values and connects to the Redux store
 * to manage admin permissions and user information.
 *
 * @param {MFNavProps} props - The properties for the component, including the current admin,
 * permissions, and the list of admin users.
 * @returns {JSX.Element} The rendered MFNav component.
 */
export default function MFNav() {
  return (
    <MFNavProvider>
      <MFNavHeader />
      <MFNavSidebarContainer>
        <Stack w="full" alignItems="center" spacing="0">
          <MFNavSidebarHeader />
        </Stack>
        <MFNavSidebarBody />
        <Stack w="full" alignItems="center" spacing="0">
          <Divider m="0" />
          <MFNavSidebarFooter />
        </Stack>
      </MFNavSidebarContainer>
    </MFNavProvider>
  )
}
